import { Cause, CauseMarshaller } from 'app/constants/schemas/Cause';
import { Map, MapMarshaller } from 'app/constants/schemas/Map';
import vmClient from 'app/services/vmClient';
import { Entity, IEntity, IEntityType } from 'app/types/entity';

export interface IError extends IEntity {
  attributes: {
    status: number | null;
    detail: string | null;
    title: string | null;
    code: string | null;
    meta: Map<string, unknown> | null;
    exception: Map<string, unknown> | null;
    causes: Cause[] | null;
  };
}

export type Error = Entity<IError>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Error: IEntityType<IError> = vmClient.defineClass({
  typeName: 'Error',
  version: 1,
  attributes: {
    status: 'number',
    detail: 'string',
    title: 'string',
    code: 'string',

    // TODO: See if there is a standard structure these can be deserialized to.
    meta: {
      type: Map,
      marshaller: MapMarshaller,
    },

    exception: {
      type: Map,
      marshaller: MapMarshaller,
    },

    // The backend considers this to be an association. However, recursive associations
    // are not currently supported, so we will use a custom marshaller.
    causes: {
      type: Cause,
      marshaller: CauseMarshaller,
      collection: true,
    },
  },
});
